import React from 'react';
import { withRouter } from "react-router-dom"
import { withStyles, Grid, Typography } from '@material-ui/core';
import DeviceEventEmitter, { EventName } from '../../control/event';
import AppData from '../../model/AppData';
 
import ListView  from 'antd-mobile/lib/list-view/index';
import PullToRefresh  from 'antd-mobile/lib/pull-to-refresh';
import MRedux from '../view/MRedux';
import AppConfig from '../../control/config';
import PreviewDoubleItem from '../view/PreviewDoubleItem';
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import NoMatch from './NoMatch';

const PAGE_SIZE = 10;

class HomeFlowList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
            isRefreshing: false,
            datas: null,
            type: this.props.type,
            isLoading: false,
            changeIndex: 0,
            nowHostRecomm: [],
        }
        this.isRequirOffset = false;
        this.container = null;
    }

    shouldComponentUpdate(nextProp, nextState) {
        if (nextProp.type != this.state.type) {
            this.state.type = nextProp.type;
            this.getTypeHostRecomm();
        }
        return true;
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'HomeFlowList');
        if (AppConfig.isiOS) {
            DeviceEventEmitter.on(EventName.HOME_REFRESH, this._onRefresh, this);
        }

        MRedux.recoverState('HOME_LIST_KEY_' + this.state.type, this.state);
        if (!this.state.data || this.state.data.length == 0) {
            this.getTypeHostRecomm();
        } else {
            this.isRequirOffset = true;
            this.setState(this.state);
        }

        this.getTypeHostRecomm();
    }

    componentWillUnmount() {
        if (AppConfig.isiOS) {
            DeviceEventEmitter.off(EventName.HOME_REFRESH, this._onRefresh, this);
        }
        if (this.container && this.container.listviewRef.scrollProperties.offset !== 0) {
            this.state.offset = this.container.listviewRef.scrollProperties.offset;
        }
        MRedux.saveState('HOME_LIST_KEY_' + this.state.type, this.state);
        AppUtils.YMPush('MAIN', 'HomeFlowList');
    }

    getTypeHostRecomm = async () => {
        this.setState({ isLoading: true });
        let result = await Apis.encryptionTypeHostRecomm(this.state.type);
        console.log('HOMEFLOWLIST ==>encryptionTypeHostRecomm', result);
        this.setState({ isLoading: false });
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }

    getTypeHostRecomm = async () => {
        if (!AppData.recommAnchorData || AppData.recommAnchorData.length == 0) {
            let hostRecomm = await Apis.encryptionHostRecomm();
            if (hostRecomm.code == 200) {
                if (hostRecomm.data && hostRecomm.data.length > 0) {
                    AppData.recommAnchorData = hostRecomm.data;
                }
            }
        }
        let nowHostRecomm = [];
        for (let i = 0; i < AppData.recommAnchorData.length && i < 4; i++) {
            nowHostRecomm.push(AppData.recommAnchorData[i]);
        }

        this.setState({ nowHostRecomm: nowHostRecomm });
    }

    _onClickChange = () => {
        let { changeIndex } = this.state;
        let hostRecomm = AppData.recommAnchorData;

        changeIndex++;
        if (changeIndex * 4 >= hostRecomm.length) {
            changeIndex = 0;
        }
        let nowHostRecomm = [];
        let startIdx = changeIndex * 4;
        for (let i = startIdx; i < hostRecomm.length && i < startIdx + 4; i++) {
            nowHostRecomm.push(hostRecomm[i]);
        }
        this.setState({ nowHostRecomm: nowHostRecomm, changeIndex: changeIndex });
    }

    _handelRef = (node) => {
        this.container = node;
        if (node && this.isRequirOffset) node.scrollTo(0, this.state.offset);
    }

    _onRefresh = (e) => {
        if (!this.state.isRefreshing) {
            var state = { isRefreshing: true };
            if (e) { state.data = []; }
            this.getTypeHostRecomm();
        }
    }

    _onEndReached = () => { }

    _renderSliperHeader = () => {
        return (
            <Grid container direction='column' justifyContent='center' style={{ height: 8 }} >
            </Grid>
        );
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    _renderItem = (rowData, sectionID, rowID) => {
        const { classes } = this.props;
        return (
            <Grid style={{ width: '100%' }}>
                {
                    <Grid container className={classes.doubleItemRow} direction='row'>
                        <Grid className={classes.doubleItemCon1}>
                            {
                                rowData[0] && <PreviewDoubleItem data={rowData[0]} />
                            }
                        </Grid>
                        <Grid className={classes.doubleItemCon2}>
                            {
                                rowData[1] && <PreviewDoubleItem data={rowData[1]} />
                            }
                        </Grid>
                    </Grid>
                }
            </Grid>
        );
    }

    _renderFooter = () => {
        const { classes } = this.props;
        return (<Grid container justifyContent='center' alignItems='center' className={classes.footer}>
            <Typography style={{ fontSize: 12 }}>{''}</Typography>
        </Grid>)
    }

    render() {
        const { classes } = this.props;
        let { data, isRefreshing, isLoading, nowHostRecomm } = this.state;
        data = AppUtils.processList(data, 2);

        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        if (data && data.length > 0) {
            return (
                <div className={classes.list} style={{ overflowY: 'auto' }} >
                    <ListView
                        initialListSize={data.length}
                        style={{ width: '100%', height: '100%', maxWidth: '100%' }}
                        contentContainerStyle={{ width: '100%' }}
                        dataSource={ds.cloneWithRows(data)}
                        renderRow={this._renderItem}
                        pageSize={PAGE_SIZE}
                        useBodyScroll={false}
                        renderFooter={this._renderFooter}
                        renderHeader={this._renderSliperHeader}
                        onEndReached={this._onEndReached}
                        onEndReachedThreshold={10}
                        pullToRefresh={
                            <PullToRefresh
                                refreshing={isRefreshing}
                                onRefresh={this._onRefresh}
                            />
                        }
                        ref={el => { this._handelRef(el) }}
                    >
                    </ListView>
                </div>
            );
        }

        if (isLoading) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    {/* <CircularProgress color='secondary' size={20} /> */}
                    <NoMatch isLoding={true} />
                </div>
            );
        }
        return (
            <Grid container justifyContent='center' alignItems='center'>
                <Grid container justifyContent='center' alignItems='center' >
                    <NoMatch isLoding={false} />
                </Grid>
                {/* <Grid container justifyContent='center' alignItems='center' style={{ marginTop: 8 }}>
                    {
                        nowHostRecomm.length > 0 && <MSectionHeader title={'推荐主播'} subtitle='换一换' chevron={false} onClick={() => this._onClickChange()} />
                    }
                    <Grid container justifyContent='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                        {
                            nowHostRecomm.map((item, n) => (
                                <Grid key={n} container alignItems='center' style={{ maxWidth: '20vw', marginLeft: 8, marginRight: 8, marginBottom: 16 }}>
                                    <MAnchor showsbsb={true} data={item} name={item.nickName} avatar={item.portrait} sbusb={AppData.isStarAnchor(item.user_id)} onClick={() => this._onClicAnchor(item)} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid> */}
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    list: {
        padding: theme.spacing(0, 0, 0, 0),
        width: '100vw',
        height: '100%',
    },
    footer: {
        width: '100%',
        height: 30,
        backgroundColor: '#fff',
        marginBottom: 68,
    },
    subtitle: {
        width: '100%',
        padding: theme.spacing(0, 1),
        margin: theme.spacing(2, 0, 3, 0),
        height: theme.typography.pxToRem(18),
    },
    subtitleFlag: {
        width: 5,
        height: '90%',
        borderRadius: 3,
        backgroundColor: theme.palette.secondary.main,
        margin: theme.spacing(0, 1, 0, 0),
    },
    changeBtn: {
        backgroundColor: '#FFE0E6',
        width: 92,
        height: 24,
        borderRadius: 18,
        color: "#F82A5C",
        fontSize: 12,
        marginLeft: theme.spacing(0, 2, 0, 0),
    },
    doubleItemRow: {
        width: '100%',
        margin: theme.spacing(0, 0, 1, 0),
    },
    doubleItemCon1: {
        width: '50%',
        padding: theme.spacing(0, 0.5, 0, 1),
    },
    doubleItemCon2: {
        width: '50%',
        padding: theme.spacing(0, 1, 0, 0.5),
    },
}))(HomeFlowList));